import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';

const ButtonPanel = ({ resetSettings, showAdvanced, saveScenario, valid, complete }) => (
  <ButtonToolbar>
    <Button
      bsStyle='primary'
      bsSize='large'
      onClick={resetSettings}
    >
      Reset Settings
    </Button>
    <Button
      bsStyle='primary'
      bsSize='large'
      onClick={showAdvanced}
    >
      Toggle Advanced
    </Button>
    <Button
      bsStyle='primary'
      bsSize='large'
      onClick={saveScenario}
      disabled={!valid}
    >
      Save as Draft
    </Button>
    <Button
      bsStyle='primary'
      bsSize='large'
      onClick={complete}
      disabled={!valid}
    >
      Run Scenario
    </Button>
  </ButtonToolbar>
);

ButtonPanel.propTypes = {
  resetSettings: PropTypes.func,
  showAdvanced: PropTypes.func,
  saveScenario: PropTypes.func,
  valid: PropTypes.boolean,
  complete: PropTypes.func,
};

export default ButtonPanel;
